import { ChangeDetectorRef, Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { ProgressReportHttpCallsService } from '../progress-report-http-calls.service';
import { ProgressReportPageComponent } from '../progress-report-page/progress-report-page.component';
import { NgxSpinnerService } from 'ngx-spinner';
declare const $: any;
@Component({
  selector: 'app-student-progress-report',
  templateUrl: './student-progress-report.component.html',
  styleUrls: ['./student-progress-report.component.scss']
})
export class StudentProgressReportComponent implements OnInit {
  @ViewChild('progressReportPage') childComponent!: ProgressReportPageComponent;
  constructor(private http: ProgressReportHttpCallsService, private spinner: NgxSpinnerService) { }
  admno: any = localStorage.getItem('studentUniqueRefNo')
  url: any = localStorage.getItem('url')
  studentName: any;
  admissionNumber: any;
  parentName: any;
  studyclass: any;
  section: any;
  Course: any;
  count:any=0;
  token: any = ''

  ngOnInit(): void {
    this.studentDetails(this.admno);
  }
  studentDetails(admno: any) {
    this.spinner.show();
    this.http.getStudentDetails(this.url, this.token, admno).subscribe((res: any) => {
      if (res) {

        // Set values using jQuery
        $("#studentName").text(res.name || "_");
        $("#admissionNumber").text(res.admNo || "_");
        $("#parentName").text(res.fname || "_");
        $("#section").text(res.section || "_");
        $("#studyclass").text(res.classYear || "_");
        $("#Course").text(res.programName || "_");
      }
      if(this.count!=0){
        this.childComponent!.changetab("tab1");
      }
      this.count++;
      
    });
    this.spinner.hide();
  }


}
